import { validateNumber, validateString } from 'avilatek-utils';
import { Address } from '../../models';

export function validateAddressForm({
  country,
  state,
  /**
    @Deprecated 
  */
  city,
  municipality,
  address1,
  address2,
  zip,
}: Partial<Address>): string {
  if (!validateString(country) && country !== '') {
    return 'El país de la dirrección es inválido';
  }
  if (!validateString(state) && state !== '') {
    return 'El estado de la dirrección es inválido';
  }
  /*
   * @Deprecated
   */
  // if (!validateString(city)) {
  //   return 'La ciudad de la dirrección es inválido';
  // }
  if (!validateString(municipality) && municipality !== '') {
    return 'El municipio de la dirrección es inválido';
  }
  if (!validateString(address1) && address1 !== '') {
    return 'La Calle/Avenida/Esquina de la dirrección es inválida';
  }
  if (!validateString(address2) && address2 !== '') {
    return 'El Edif/Apto/Piso/Casa de la dirrección es inválido';
  }
  if (!validateNumber(zip) && zip !== '') {
    return 'El código postal es inválido';
  }
  return '';
}
